import MotifDepreciationStockFormController from './motif.depreciation.stock.form.controller';

export default {
    template: require('./motif.depreciation.stock.form.html'),
    controller: MotifDepreciationStockFormController
};
